"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButtonList = exports.IconButtonActionsPlacement = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var IconButton_1 = require("../IconButton");
var IconButtonList_style_1 = require("./IconButtonList.style");
var enums_1 = require("../../enums");
var ActionList_1 = require("./ActionList/ActionList");
var enums_2 = require("../../enums");
var IconButtonActionsPlacement;
(function (IconButtonActionsPlacement) {
    IconButtonActionsPlacement["BOTTOM_END"] = "actionsListPlacementBottomEnd";
    IconButtonActionsPlacement["BOTTOM_START"] = "actionsListPlacementBottomStart";
    IconButtonActionsPlacement["TOP_END"] = "actionsListPlacementTopEnd";
    IconButtonActionsPlacement["TOP_START"] = "actionsListPlacementTopStart";
})(IconButtonActionsPlacement = exports.IconButtonActionsPlacement || (exports.IconButtonActionsPlacement = {}));
var IconButtonList = function (_a) {
    var name = _a.name, actionsId = _a.actionsId, actions = _a.actions, actionsPlacement = _a.actionsPlacement, _b = _a.iconSize, iconSize = _b === void 0 ? enums_2.Size.extraSmall : _b, icon = _a.icon, _c = _a.variant, variant = _c === void 0 ? enums_2.Variant.contained : _c, _d = _a.color, color = _d === void 0 ? enums_1.Color.secondary : _d, collapseHandler = _a.collapseHandler;
    var classes = (0, IconButtonList_style_1.useIconButtonListStyles)();
    var DEFAULT_ACTIONS_LIST_PLACEMENT = IconButtonActionsPlacement.BOTTOM_START;
    var _e = (0, react_1.useState)(false), isActionsListExpanded = _e[0], setIsActionsListExpanded = _e[1];
    var ref = (0, react_1.useRef)(null);
    var actionsListPlacementSelector = actionsPlacement
        ? classes[actionsPlacement]
        : classes[DEFAULT_ACTIONS_LIST_PLACEMENT];
    (0, react_1.useEffect)(function () {
        document.addEventListener('keydown', onKeypressHandler, true);
        document.addEventListener('click', onOutsideClickHandler, true);
        return function () {
            document.removeEventListener('keydown', onKeypressHandler, true);
            document.removeEventListener('click', onOutsideClickHandler, true);
        };
    });
    var onKeypressHandler = function (event) {
        var ESCAPE = 'Escape';
        if (event.key === ESCAPE) {
            setIsActionsListExpanded(false);
            collapseHandler === null || collapseHandler === void 0 ? void 0 : collapseHandler(false);
        }
    };
    var onOutsideClickHandler = function (event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setIsActionsListExpanded(false);
            collapseHandler === null || collapseHandler === void 0 ? void 0 : collapseHandler(false);
        }
    };
    var onButtonClickHandler = function (event) {
        event.stopPropagation();
        collapseHandler === null || collapseHandler === void 0 ? void 0 : collapseHandler(!isActionsListExpanded);
        setIsActionsListExpanded(!isActionsListExpanded);
    };
    var onCollapseHandler = function () {
        setIsActionsListExpanded(false);
        collapseHandler === null || collapseHandler === void 0 ? void 0 : collapseHandler(false);
    };
    return (react_1.default.createElement("div", { className: classes.container, ref: ref },
        react_1.default.createElement(IconButton_1.IconButton, { variant: variant, color: color, disabled: false, onClick: onButtonClickHandler, name: name, size: iconSize }, icon),
        isActionsListExpanded && (react_1.default.createElement("div", { className: "".concat(classes.actionsList, " ").concat(actionsListPlacementSelector) },
            react_1.default.createElement(ActionList_1.ActionsList, { actionsId: actionsId, actions: actions, collapseHandler: onCollapseHandler })))));
};
exports.IconButtonList = IconButtonList;
